import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { AUTHORIZATION, HOSTNAME } from "../../../common/constants";
import HorizontalNav from "../../../components/HorizontalNav";
import authTokenForAPI from "../../../utils/authTokenForAPI";
import {
  primaryColor,
  secondaryColor,
  ternaryColor,
} from "../../../utils/styleObjs";
// import { rows } from "./listSewadarUtils";

const ListSubCentres = () => {
  const [subCentresList, setSubCentresList] = useState([]);

  useEffect(() => {
    trackPromise(
      axios
        .get(`${HOSTNAME}/sub-centres`, {
          headers: { [AUTHORIZATION]: authTokenForAPI() },
        })
        .then((res) => {
          setSubCentresList(res.data);
        })
    );
  }, []);

  const columns = [
    { field: "id", headerName: "S No." },
    { field: "name", headerName: "Satsang Place name", width: 200 },
  ];

  const navLinks = [{ key: 0, label: "Home", path: "/home" }];

  return (
    <>
      <HorizontalNav navLinks={navLinks} pageName="List of Satsang Places" />
      <h2>List of Satsang Places</h2>
      <div style={{ maxWidth: "500px" }}>
        <DataGrid
          density="compact"
          showCellRightBorder
          autoHeight
          sx={{
            borderColor: primaryColor,
            backgroundColor: ternaryColor,
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor: secondaryColor,
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: primaryColor,
              color: "white",
              fontWeight: "600",

              "& .MuiSvgIcon-root": {
                color: "white",
              },
            },
            "& .MuiDataGrid-cellCheckbox .MuiSvgIcon-root": {
              color: primaryColor,
            },
          }}
          rows={subCentresList}
          columns={columns}
        />
      </div>
    </>
  );
};

export default ListSubCentres;
